
<span *ngFor="let e of equipes" style="padding-right: 2px">{{e.name}},</span>
